import { writable } from 'svelte/store'
import type { ApiError } from '../api/errors'

/** Sidebar collapsed/expanded — persisted in-memory only for now. */
export const sidebarCollapsed = writable(false)

/** Last unhandled API error shown in the global banner. */
export const apiError = writable<ApiError | null>(null)

export function toggleSidebar(): void {
  sidebarCollapsed.update((v) => !v)
}

export function setApiError(error: ApiError | null): void {
  apiError.set(error)
}

export function clearApiError(): void {
  apiError.set(null)
}
